import { cn } from '../../lib/cn';
import type { ImplementationRow } from '../../enterprisebeta/framework';

type Props = { steps?: ImplementationRow[] };

export function ImplementationGuidePanel({ steps = [] }: Props) {
  return (
    <div className="space-y-2">
      {steps.map((s) => (
        <div key={s.step + s.tenant} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{s.step}</p>
              <p className="text-xs text-slate-500">{s.tenant}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              s.status === 'completed' ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300' :
              s.status === 'in_progress' ? 'bg-brand-50 text-brand-700 dark:bg-brand-950 dark:text-brand-300' :
              'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {s.status.replace('_', ' ')}
            </span>
          </div>
          <div className="mt-2 h-1.5 overflow-hidden rounded-full bg-slate-100 dark:bg-slate-800">
            <div className={cn('h-full rounded-full', s.progress === 100 ? 'bg-success-500' : 'bg-brand-500')} style={{ width: `${s.progress}%` }} />
          </div>
        </div>
      ))}
    </div>
  );
}
